import { CalendarIcon, XCircleIcon } from "@heroicons/react/solid";
import React from "react";
import { useState } from "react";
import DoubleClickEdit from "../../../../../components/DoubleClickEdit";
import ReactDatePicker from "../../../../../components/ReactDatePicker";
import { formatTaskDate } from "./taskDateFormatters";


/**
 * Inline double-click-editable due-date field for a task.
 * Displays the current date or "No due date" in read mode. Switching to edit
 * mode shows a date picker. Selecting a date or clearing the value immediately
 * calls `handleSubmitEdit` and returns to read mode.
 *
 * @param {object}   props
 * @param {Date|string|null} props.defaultValue    - Initial due date value
 * @param {Function}         props.handleSubmitEdit - Called with the new date value (or null) on change
 */
const DueDate = ({ defaultValue, handleSubmitEdit }) => {
    const [value, setValue] = useState(defaultValue);
    const [showEdit, setShowEdit] = useState(false);

    const handleChange = (newValue) => {
        setValue(newValue);
        handleSubmitEdit(newValue);
        setShowEdit(false);
    };

    const handleClearValue = () => {
        setValue(null);
        handleSubmitEdit(null);
        setShowEdit(false);
    }
    return (
        <DoubleClickEdit
            showEdit={showEdit}
            setShowEdit={setShowEdit}
            defaultComponent={
                <div className="flex items-center text-xs text-gray-500">
                    <CalendarIcon
                        className="mr-1 h-3.5 w-3.5 flex-shrink-0 text-gray-400"
                        aria-hidden="true"
                    />
                    {value ? (
                        <div className="group flex items-center">
                            <time dateTime={value}>
                                {formatTaskDate(value)}
                            </time>
                            <button onClick={handleClearValue} aria-label="Clear due date" className="ml-1 invisible group-hover:visible">
                                <XCircleIcon className="h-3.5 w-3.5 text-gray-400" aria-hidden="true" />
                            </button>
                        </div>
                    ) : (
                        <p className="min-w-max">No due date</p>
                    )}
                </div>
            }
            editComponent={
                <ReactDatePicker
                    className="input-primary z-50"
                    selected={value}
                    onChange={(date) => handleChange(new Date(date))}
                />
            }
            handleSubmitEdit={() => { }}
            componentName="due_date"
        />
    );
};

export default DueDate;
